import { TableLink } from "components/BaseTableV3/TableLink";
import { EmailExemptionsTableActions } from "./EmailExemptionsTableActions";

export const getEmailExemptionsTableColumns = () => {
  return [
    {
      header: "ID",
      id: "ID",
      accessorKey: "id",
      width: 60,
      cell: ({ row }) => (
        <span className="tw:font-bold">{row.original?.id}</span>
      ),
    },
    {
      header: "Email Address",
      id: "Email Address",
      accessorKey: "email_address.email",
    },
    {
      header: "Campaign",
      id: "campaign.name",
      accessorKey: "campaign.name",
      cell: ({ row }) => (
        <TableLink href={`/campaigns/${row.original.campaign.id}`}>
          {row.original.campaign.name}
        </TableLink>
      ),
    },
    {
      header: "Created By",
      id: "Created By",
      accessorKey: "creator_user.full_name",
    },
    {
      header: "Justification",
      id: "Justification",
      accessorKey: "justification",
    },
    {
      header: "Source",
      id: "Source",
      accessorKey: "source",
    },
    {
      header: "Notes",
      id: "Notes",
      accessorKey: "notes",
    },
    {
      header: <div></div>,
      id: "Actions",
      accessorKey: "actions",
      enableSorting: false,
      enableResizing: false,
      size: 60,
      meta: {
        isDisplay: true,
      },
      cell: ({ row }) => (
        <EmailExemptionsTableActions original={row.original} />
      ),
    },
  ];
};
